import React, { useState } from "react";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import ListTable from "./ListTable";

const List = ({ searchTerm }: { searchTerm: string }) => {
  const [list, setList] = useState<number>(1);
  return (
    <div className="w-full ">
      <div className="w-full flex py-6 px-2 justify-between items-center">
        <button
          onClick={() => setList((prev) => (prev === 1 ? 2 : 1))}
          className="text-white text-[28px]"
        >
          <MdOutlineKeyboardArrowLeft />
        </button>
        <h4 className="text-white font-bold text-[16px]">
          {list === 1
            ? "What is your primary use of DeeX app?"
            : list === 2
            ? " How much volume do you trade monthly?"
            : ""}
        </h4>
        <button
          onClick={() => setList((prev) => (prev === 1 ? 2 : 1))}
          className="text-white text-[28px]"
        >
          <MdOutlineKeyboardArrowRight />
        </button>{" "}
      </div>
      <ListTable searchTerm={searchTerm} list={list} />
    </div>
  );
};

export default List;
